import Usuario from "model/administracao/cadastro/Usuario";
import { BaseModel } from "model/BaseModel";
import Veiculo from "model/gestao/frotas/Veiculo";
import ItemRota from "./ItemRota";

export default class Rota implements BaseModel {

    id: number | null;
    codigo = "";
    nome: string;
    status: string;
    dataPrevistaInicio: Date | null;
    motorista: Usuario|null;
    veiculo: Veiculo|null;
    itens: ItemRota[];

    constructor(
        id: number | null = null,
        nome: string = "",
        status: string = "CRIADA",
        dataPrevistaInicio: Date | null = null,
        motorista: Usuario|null = null,
        veiculo: Veiculo|null = null,
        itens: ItemRota[] = []
    ) {
        this.id = id;
        this.nome = nome;
        this.status = status;
        this.dataPrevistaInicio = dataPrevistaInicio;
        this.motorista = motorista;
        this.veiculo = veiculo;
        this.itens = itens;
    }
}